import { render, staticRenderFns } from "./PayPalPage.vue?vue&type=template&id=9e45645a&scoped=true&"
import script from "./PayPalPage.vue?vue&type=script&lang=js&"
export * from "./PayPalPage.vue?vue&type=script&lang=js&"
import style0 from "./PayPalPage.vue?vue&type=style&index=0&id=9e45645a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e45645a",
  null
  
)

export default component.exports